import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 3,
  class: "mt-3 white-space-pre-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPark = _resolveComponent("IconPark")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (_ctx.user.isLimitedManager())
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.feed.compiled_name), 1))
        : (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "text-indigo-400",
            href: `/feeds/${_ctx.feed.id}`,
            target: "_blank"
          }, _toDisplayString(_ctx.feed.compiled_name), 9, _hoisted_2)),
      (!_ctx.user.isLimitedManager())
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            class: "ml-2",
            href: `/statistics/staff?filters=${_ctx.encodeStatisticsFilters({ ..._ctx.statisticsFilters, feed_id: [_ctx.feed.id] })}`,
            target: "_blank"
          }, [
            _withDirectives(_createVNode(_component_IconPark, {
              class: "text-blue-600 cursor-pointer",
              type: "chart-histogram-two",
              theme: "outline",
              size: _ctx.iconSize
            }, null, 8, ["size"]), [
              [
                _directive_tooltip,
                _ctx.$t('statistics'),
                void 0,
                { right: true }
              ]
            ])
          ], 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    (_ctx.feed.max_revenue_per_day)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('max_revenue_per_day')) + ": " + _toDisplayString(_ctx.$n(_ctx.feed.max_revenue_per_day, 'payout')) + " (" + _toDisplayString(_ctx.$t(_ctx.FEED_MAX_REVENUE_PER_DAY_STRATEGIES_MAP[_ctx.feed.max_revenue_per_day_strategy].translate_key)) + ")", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, _toDisplayString(_ctx.$t('revshare')) + ": " + _toDisplayString(_ctx.$n(_ctx.feed.revshare / 100, 'percent')), 1),
    (_ctx.feed.fixed_bid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('fixed_cpm')) + ": " + _toDisplayString(_ctx.$n(_ctx.feed.fixed_bid * 1000, 'payout')), 1))
      : _createCommentVNode("", true),
    (_ctx.feed.max_qps)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, "QPS: " + _toDisplayString(_ctx.feed.max_qps), 1))
      : _createCommentVNode("", true),
    (_ctx.showComment && _ctx.feed.comment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.feed.comment), 1))
      : _createCommentVNode("", true)
  ]))
}